
import UserList from "./UserLogin"
const SectionLogin = () => {
  return (
    <section id="services" className="services">
      <div className="container" data-aos="fade-up">

        <div className="section-title">
          <h2>進入課程前，請先指定您的身份</h2>
        </div>

        <UserList />

      </div>
    </section>
  )
}

export default SectionLogin

